import { render } from "./kisiForm.vue?vue&type=template&id=4e44b336"
import script from "./kisiForm.vue?vue&type=script&lang=js"
export * from "./kisiForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__